import React from 'react'
import Navbar from '../../components/navbar_poc'
import bg from '../../assets/images/bg.jpg'
import { Link, useParams } from 'react-router-dom'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import BlogSidebar from '../../components/blog-sidebar'

import blogImg from '../../assets/images/blog/14.jpg'
import BlogAbout from '../../components/blog-about'
import BlogComments from '../../components/blog-comments'
import { blogData } from '../../data/blog-data'
import Footer from '../../components/footer'

export default function BlogStandardPost() {
  let params = useParams();
  let id = params.id
  let data = blogData.find((item)=>item.id === parseInt(id))

  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">Standard Post</h4>
                          <p className="text-muted mb-0">We present and write attractive blog posts with Sidebar</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Blog</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Blog & Sidebar</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-lg-8 col-md-6">
                  <div className="card blog blog-primary border-0 rounded-0">
                      <div className="card-title mb-0">
                          <div className="section-title text-center">
                              <Link to="#" className="text-primary h6 text-decoration-underline">{data?.tag ? data?.tag : 'Couple'}</Link>
                              <h4 className="my-2">{data?.title ? data?.title : 'Take only memories, leave only footprints'}</h4>
                              <span className="text-muted mb-0">{data?.date ? data?.date : '15th March 2023'}</span>
                          </div>
                      </div>

                      <div className="mt-4">
                          <img src={data?.image ? data?.image : blogImg} className="img-fluid rounded shadow" alt=""/>
                      </div>
                      <BlogAbout/>
                  </div>
                  <BlogComments/>
              </div>

              <div className="col-lg-4 col-md-6">
                  <BlogSidebar/>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
